import { Registration } from "@p0security/shared/integrations/types";

import { AwsLambdaNotifierComponents } from "./components.ts";

export const AwsLambdaIconUrl =
  "https://upload.wikimedia.org/wikipedia/commons/5/5c/Amazon_Lambda_architecture_logo.svg";

export const AwsLambdaRegistration = Registration({
  category: "other",
  components: AwsLambdaNotifierComponents,
  docs: { install: "aws", request: "aws/requesting-access" },
  itemKind: "notifier",
  label: "AWS Lambda",
  logoUrl: AwsLambdaIconUrl,
  maturity: "ga",
});
